/*       */
// We need to move this component to platform-ui
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioGroup } from '@mic3/platform-ui';
import MuiRadio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { createEvent } from 'app/utils/http/event';

const RadioGroupWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 4px;
    padding: 8px 12px;
`;

const RadioGroupLabel = styled.label`
    font-size: 0.75rem;
    color: ${({ theme, error }) => error ? theme.material.colors.error.main : theme.material.colors.text.secondary};
    margin-bottom: 4px;

    .MuiFormLabel-asterisk {
        color: ${({ theme }) => theme.material.colors.error.main};
    }
`;

class RadioButtonsGroup extends PureComponent {
    static propTypes = {
        ...(MuiRadio || {}).propTypes,
        onChange: PropTypes.func.isRequired,
        label: PropTypes.string,
        required: PropTypes.bool,
        error: PropTypes.bool,
        helperText: PropTypes.string,
        labelPlacement: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
            })
        ),
    };

    static defaultProps = {
        color: 'primary',
    };

    @bind
    onChange(e) {
        const { name, onChange } = this.props;
        const { value } = e.target;
        const event = createEvent('change', { name, value });
        onChange && onChange(event);
    }

    render() {
        const { RadioProps, labelPlacement, color, value, onChange, options, disabled, label, required, error, helperText, ...restProps } = this.props;
        if (!options?.length) {
            return null;
        }
        return (
            <RadioGroupWrapper>
                {label && (
                    <RadioGroupLabel error={error}>
                        {label}{required && <span className="MuiFormLabel-asterisk"> *</span>}
                    </RadioGroupLabel>
                )}
                <RadioGroup value={value} disabled={disabled} onChange={this.onChange} {...restProps}>
                    {options.map(({ label, value }) => (
                        <FormControlLabel
                            key={value}
                            label={label}
                            value={value}
                            control={<MuiRadio color={color} {...RadioProps} />}
                            labelPlacement={labelPlacement || 'end'}
                            disabled={disabled}
                        />
                    ))}
                </RadioGroup>
                {helperText && (
                    <FormHelperText error={error}>{helperText}</FormHelperText>
                )}
            </RadioGroupWrapper>
        );
    }
}

export default RadioButtonsGroup;
